import React, { useState, useEffect } from 'react';
import { Link, useLocation, useHistory } from 'react-router-dom';
import "../../../common.css";
import "../../../investorAcademy.css";
import ChildInvestorAcademyCommon from '../../../../../../components/common/InvestorAcademyCommon/ChildInvestorAcademyCommon';
import SelectingWarrantCommonTabs from '../../../../../../components/common/SelectingWarrantCommonTabs';
import SelectingWarrentImg from '../../../../../../components/common/SelectingWarrentImg'


const SelectImpliedVolatility = (props) => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    const location = useLocation();
    const history = useHistory();
    const [openLive, setOpenLive] = useState(false);
    const [imageUrl, setImageUrl] = useState("");

    return (
        <div id="investor_academy">
            <div className="imgbg" />
            <div className="mainbg"></div>

            <div id="main">
                <div id="maintable" className='share_capital Common_warrent' style={{ display: 'table', width: '100%', tableLayout: 'fixed' }}>
                    <div style={{ display: 'table-row' }}>
                        <div id="leftbar" className="hidden-xs" style={{ display: 'table-cell', width: '80px' }} />
                        <div id="maincontainer" style={{ display: 'table-cell', width: '100%' }}>
                            <div id="mainnav">
                                <table style={{ width: '100%', tableLayout: 'fixed', borderBottom: '1px solid #353223' }}>
                                    <tbody><tr>
                                        <td width="20%" style={{ textAlign: 'left', visibility: 'hidden' }}>
                                            <table className="hasprev hidden-xs" style={{ width: '100%', height: '100%', tableLayout: 'fixed' }}>
                                                <tbody><tr>
                                                    <td width="33px"><div className="prev left" /></td>
                                                    <td>
                                                        <div className="prevlbl left">
                                                            <div className="prevtitle " style={{ textAlign: 'left' }} />
                                                            <div className="prevname " style={{ textAlign: 'left' }}>Gearing Level</div>
                                                        </div>
                                                    </td>
                                                </tr>
                                                </tbody></table>
                                        </td>
                                        <td width="60%" style={{ textAlign: 'center' }}>
                                            <div id="pagetitlediv" style={{ width: '365px', height: '100%', borderBottom: '1px solid #FFD843', margin: 'auto' }}>
                                                <div id="ptitle" style={{ fontFamily: 'HelveticaNeueThinCond', fontSize: '25px', color: 'white', letterSpacing: '1px' }}>How to select a Warrant?</div>
                                                <div id="pname" style={{ fontFamily: 'HelveticaNeueThinCond', fontSize: '30px', color: '#FFD843', letterSpacing: '1px', paddingTop: '5px', paddingBottom: '5px' }}>Implied Volatility</div>
                                            </div>
                                        </td>
                                        <td width="20%" style={{ textAlign: 'right', visibility: 'hidden' }}>
                                            <table className="hasnext  hidden-xs" style={{ width: '100%', height: '100%', tableLayout: 'fixed' }}>
                                                <tbody><tr>
                                                    <td>
                                                        <div className="nextlbl right">
                                                            <div className="nexttitle " style={{ textAlign: 'right' }} />
                                                            <div className="nextname " style={{ textAlign: 'right' }}>Warrant Spreads</div>
                                                        </div>
                                                    </td>
                                                    <td width="33px"><div className="next right" /></td>
                                                </tr>
                                                </tbody></table>
                                        </td>
                                    </tr>
                                    </tbody></table>
                            </div>
                            <div id="maincontent" style={{ marginLeft: '10px', marginRight: '10px', paddingTop: '40px', marginBottom: '60px' }}>
                                <div id="mainscroll" style={{ height: '100%', overflowX: 'hidden', overflowY: 'auto', paddingLeft: '90px', paddingRight: '90px' }}>
                                    <div id="mainscrollcontent">
                                        <style dangerouslySetInnerHTML={{ __html: "\n            .contentbox table{\n                margin: 0 auto;\n            }\n            .contentbox table thead th{\n                background-color: #FFD400;\n            }\n            .contentbox table tbody td,\n            .contentbox table thead th{\n                padding:0.5em 1em;\n                color:#000000;\n                text-align: center;\n            }\n            .contentbox table tbody td.bgc0{\n                background-color: #FFF4D2;\n            }\n            .contentbox table thead th.bgc1 {\n                background-color: #9E9FA1;\n            }\n            .contentbox table tbody td.bgc2{\n                background-color: #C0C1C2;\n            }\n            .contentbox table tbody tr.active td{\n                background-color: #FD8C8F;\n            }\n            .ms .contentbox table.ctable\n            .xs .contentbox table.ctable,\n            .xxs .contentbox table.ctable{\n                font-size:11px;\n            }\n            .ms .contentbox table  td,\n            .ms .contentbox table  th,\n            .xs .contentbox table  td,\n            .xs .contentbox table  th,\n            .xxs .contentbox table td,\n            .xxs .contentbox table th{\n                padding:0.5em;\n            }\n            .imgholder img{\n                max-width: 895px;\n            }\n            .imgholder .imgmask{\n                position:relative;\n                margin:auto;\n            }\n            .imgholder .area{\n                position:absolute;\n                display:block;\n            }\n        " }} />
                                        <div className="contentbox">
                                            <p>When choosing a warrant, we suggest that investors consider the following 4 steps:</p>

                                            <div className="imgholder hidden-xs">
                                                <SelectingWarrantCommonTabs Location={location} Hist={history} />
                                            </div>
                                            <p>
                                                With the list of warrants narrowed from the earlier steps, you should look at the implied volatility of the warrants in the list. The implied volatility is a key factor that affects a warrant’s pricing. It is the level of volatility that is implied by the current market price of the warrant. Implied volatility enables you to compare the relative prices of similar warrants.
                                            </p>
                                            <p>
                                                In general, a warrant with a lower implied volatility is relatively cheaper and vice versa (all other pricing factors held constant). All else constant, you would generally select the warrant with the lowest implied volatility. If you have two warrants with the same exercise price, expiry date and exercise ratio, a higher implied volatility in one warrant will translate to a higher warrant price.
                                            </p>
                                            <div className="imgholder">
                                                <img src='/img/education/impliedVol.png' style={{ maxWidth: '321px' }} />
                                            </div>

                                            <p>
                                            </p><p>
                                                Click <Link to="/edu/useful-warrant-terms/implied-volatility" target="_blank">here</Link> for more information on implied volatility.
                                            </p>
                                            <p />
                                            <h2>
                                                Check the Implied Volatility
                                            </h2>
                                            <p>
                                                The remaining warrants on the list have similar exercise prices and expiry dates. However, Warrant D is more expensive than the other two, due to its higher implied volatility.
                                            </p>
                                            <div className="imgholder">
                                                <img style={{ maxWidth: '888px' }} src='/img/education/table3.png' />
                                                <div className="map_pop">
                                                    <div
                                                        className="how_put"
                                                        data-bs-toggle="collapse"
                                                        href="#popup-image"
                                                        role="text"
                                                        aria-expanded="false"
                                                        aria-controls="popup-image"
                                                        onClick={() => { return setOpenLive(true), setImageUrl("/img/education/tableMob3.png") }}
                                                    >View table
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div id="rightbar" className="hidden-xs" style={{ display: 'table-cell', width: '80px' }}>
                                </div>
                            </div>
                        </div>
                        <div id="rightbar" className="hidden-xs" style={{ display: 'table-cell', width: '80px' }}>
                        </div>
                    </div>
                </div>
            </div>

            <div
                id="bottom"
                style={{
                    position: "fixed",
                    width: "100%",
                    bottom: "0px",
                    height: "40px",
                    backgroundColor: "#101010",
                    zIndex: 10000,
                }}
            >
                <div
                    className="hidden-xs hidden-xxs"
                    style={{
                        display: "table",
                        width: "100%",
                        textAlign: "center",
                        color: "#8F8F8F",
                        fontSize: "11px",
                        lineHeight: "40px",
                    }}
                >
                    <div className='copyright_sec'>
                        Copyright (c) 2016 Macquarie Group Limited ABN 94 122 169 279. All rights
                        reserved.
                    </div>
                </div>
                <div
                    style={{
                        position: "absolute",
                        width: "46%",
                        height: "35px",
                        right: "10px",
                        bottom: "5px",
                    }}
                >
                    <table
                        className="hasnext"
                        style={{ width: "100%", height: "100%", tableLayout: "fixed" }}
                    >
                        <tbody>
                            <tr>
                                <td>
                                    <div className="nextlbl right">
                                        <div
                                            className="nextname "
                                            style={{ textAlign: "right", fontSize: "15px" }}
                                        >
                                            <Link to="/edu/select-warrant/selecting-warrant/warrant-spread">
                                                <span className="prevname ">Warrant Spreads</span>
                                            </Link>
                                        </div>
                                    </div>
                                </td>
                                <td width="33px">
                                    <Link to="/edu/select-warrant/selecting-warrant/warrant-spread">
                                        <div className="next right" />
                                    </Link>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div
                    style={{
                        position: "absolute",
                        width: "46%",
                        height: "35px",
                        left: "10px",
                        bottom: "5px",
                    }}
                >
                    <table
                        className="hasprev"
                        style={{ width: "100%", height: "100%", tableLayout: "fixed" }}
                    >
                        <tbody>
                            <tr>
                                <td width="33px">
                                    <Link to="/edu/select-warrant/selecting-warrant/gearing-level">
                                        <div className="prev left" />
                                    </Link>
                                </td>
                                <td>
                                    <div className="prevlbl left">
                                        <div
                                            className="prevname "
                                            style={{ textAlign: "left", fontSize: "15px" }}
                                        >
                                            <Link to="/edu/select-warrant/selecting-warrant/gearing-level">
                                                <span> Gearing Level</span>
                                            </Link>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div id="dotbar" className="hidden-sm hidden-xs" style={{}}>
                {/* <div className="dbtn dbtn-seminarbtn">
                    <Link
                        className="seminarbtn"
                        to="/education/seminar"
                    >
                        <img src='/img/education/button-static.png' alt="image" />
                    </Link>
                </div> */}
                <SelectingWarrentImg Open={openLive} OpenModel={() => setOpenLive(!true)} Data={imageUrl} />
                <ChildInvestorAcademyCommon Location={location} Hist={history} />
            </div>

        </div>
    );
}
export default SelectImpliedVolatility;